'use client';
import { useEffect } from 'react';

// Модульный счетчик — переживает ремаунты компонентов, но общий на все открытые модалки в приложении.
let lockCount = 0;
let savedScrollY = 0;

/**
 * Блокирует скролл body, пока isOpen === true.
 * Использует position: fixed вместо overflow: hidden + перехвата wheel/touch,
 * потому что overflow:hidden в связке с ручным preventDefault на wheel/touchmove
 * ненадежен (гонки в StrictMode, скролл "просачивается" на некоторых браузерах/трекпадах).
 * position: fixed убирает саму возможность скролла страницы физически.
 */
export function useScrollLock(isOpen: boolean) {
  useEffect(() => {
    if (!isOpen) return;

    lockCount++;

    if (lockCount === 1) {
      savedScrollY = window.scrollY;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${savedScrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }

      window.dispatchEvent(new CustomEvent('lenis-lock', { detail: { isLocked: true } }));
    }

    return () => {
      lockCount = Math.max(0, lockCount - 1);

      if (lockCount === 0) {
        const body = document.body;
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        body.style.paddingRight = '';

        window.scrollTo(0, savedScrollY);
        window.dispatchEvent(new CustomEvent('lenis-lock', { detail: { isLocked: false } }));
      }
    };
  }, [isOpen]);
}
